/**
 * @file index.tsx
 *
 * @fileoverview Renders the job search split view.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ErrorGenericIcon from '~/vcl/icons/ErrorGeneric';
import { EmptyElement } from '~/vcl/molecules/02-empty';
import Link from '~/jobiqo/components/Link';

export const LayoutMainError = () => {
  return (
    <EmptyElement
      icon={
        <ErrorGenericIcon
          color="primary"
          width="300"
          height="300"
          title="Error"
        />
      }
    >
      <p>
        <FormattedMessage
          id="app_layout_error"
          defaultMessage="There was an unexpected error on the website. We are monitoring the error so that a fix can be made and it doesn't happen again.
              In the meanwhile try to reload the page or {contactLink} us if the error persists."
          values={{
            contactLink: (
              <Link href="/contact">
                <FormattedMessage
                  id="app_layout_error_contact_label"
                  defaultMessage="Contact"
                />
              </Link>
            ),
          }}
        />
      </p>
    </EmptyElement>
  );
};
export default LayoutMainError;
